import { defineMessages } from 'react-intl';

const messages = defineMessages({
  welcome: {
    id: 'dashboard.welcome',
    defaultMessage:
      'Welcome to the {brand, select, valtra {Valtra} massey {Massey Ferguson} other {AGCO}} customer experience portal',
    description: 'Welcome message on the dashboard',
  },
  letsGetStartedButton: {
    id: 'dashboard.letsGetStartedButton',
    defaultMessage: 'Let’s get started',
    description: 'Welcome message on the dashboard',
  },
  claimYourBusinessDescription: {
    id: 'dashboard.claimYourBusinessDescription',
    defaultMessage:
      'If you already have an activation code you can claim your business. This will provide you with further functions to enhance your experience.',
    description: 'Claim your business description',
  },
  claimYourBusinessButton: {
    id: 'dashboard.claimYourBusinessButton',
    defaultMessage: 'Claim your business',
    description: 'Claim your business button',
  },
  activationCodeTitle: {
    id: 'dashboard.activation.codeTitle',
    defaultMessage: 'Activation code',
    description: 'Activation code title',
  },
  activationCodeDescription: {
    id: 'dashboard.activation.codeDescription',
    defaultMessage: 'To register with the CEP, enter the activation code below.',
    description: 'Activation code description',
  },
  activationCompanyDetails: {
    id: 'dashboard.activation.companyDetails',
    defaultMessage: 'Company details',
    description: 'Company details',
  },
  activationCompanyName: {
    id: 'dashboard.activation.companyName',
    defaultMessage: 'Company name',
    description: 'Company name',
  },
  activationCompantyDetailsDescription: {
    id: 'dashboard.activation.compantyDetailsDescription',
    defaultMessage: 'Please check company details',
    description: 'Activation code company details description',
  },
  welcomeFirstName: {
    id: 'dashboard.welcomeFirstName',
    defaultMessage: 'Welcome {firstName}',
    description: 'Dashboard welcome message',
  },
  welcomeUser: {
    id: 'dashboard.welcomeUser',
    defaultMessage: 'Welcome {firstName}',
    description: 'Dashboard welcome message',
  },
  chooseYourAction: {
    id: 'dashboard.chooseYourAction',
    defaultMessage: 'Choose your action',
    description: 'Dashboard welcome subtitle',
  },
  optionServiceAndInfoTitle: {
    id: 'dashboard.options.serviceAndInfo.title',
    defaultMessage: 'Service & {lineBreak}Information',
    description: 'Dashboard options, service and information, title',
  },
  optionServiceAndInfoSubtitle: {
    id: 'dashboard.options.serviceAndInfo.subtitle',
    defaultMessage: 'Services for Your Fleet & more',
    description: 'Dashboard options, service and information, subtitle',
  },
  optionServiceAndInfoDescription: {
    id: 'dashboard.options.serviceAndInfo.description',
    defaultMessage:
      'Gain comprehensive access to vital details regarding your machinery and equipment, such as <bold>warranty coverage, Active PSPs,</bold> and latest <bold>operator manuals</bold>. Find the <bold>nearest dealer</bold> in your area and rest assured that our team is fully committed to <bold>support your journey</bold>.',
    description: 'Dashboard options, service and information, description',
  },
  optionSmartFarmingTitle: {
    id: 'dashboard.options.smartFarming.title',
    defaultMessage: 'Smart {lineBreak}Farming',
    description: 'Dashboard options, smart farming, title',
  },
  optionSmartFarmingSubtitle: {
    id: 'dashboard.options.smartFarming.subtitle',
    defaultMessage: 'Your Connected Fleet',
    description: 'Dashboard options, smart farming, subtitle',
  },
  optionSmartFarmingDescription: {
    id: 'dashboard.options.smartFarming.description',
    defaultMessage:
      'Find your <bold>Connectivity Information</bold> and <bold>Telemetric functions</bold> in this Portal. Take advantage of our Smart farming application to <bold>organize</bold> your <bold>tasks, fields & fleet</bold>.',
    description: 'Dashboard options, smart farming, description',
  },
  yourFleetTitle: {
    id: 'dashboard.yourFleet.title',
    defaultMessage: 'Your fleet',
    description: 'Your fleet card title',
  },
  yourFleetDescription: {
    id: 'dashboard.yourFleet.description',
    defaultMessage:
      'We are validating your business. As soon as it is approved you are able to use FendtONE. This can take up to a few days.{lineBreak}Thank you for your understanding.',
    description: 'Your fleet card description',
  },
  yourFleetDescriptionVerifiedBusiness: {
    id: 'dashboard.yourFleet.descriptionVerifiedBusiness',
    defaultMessage: 'Your business has been verified. You can now access FendtONE.',
    description: 'Your fleet card description for verified business',
  },
  howCanWeHelp: {
    id: 'dashboard.howCanWeHelp',
    defaultMessage: 'How can we help you?',
    description: 'Help message on dashboard',
  },
  fleetOverviewTitle: {
    id: 'dashboard.tiles.fleetOverview.title',
    defaultMessage: 'Fleet Overview',
    description: 'Fleet overview title',
  },
  fleetOverviewDescription: {
    id: 'dashboard.fleetOverview.description',
    defaultMessage:
      'Check your Fleet Overview, add machines or access machine detail information to all machines in your fleet.',
    description: 'Fleet overview description',
  },
  warrantyTitle: {
    id: 'dashboard.tiles.warranty.title',
    defaultMessage: 'Warranty',
    description: 'Warranty title',
  },
  warrantyDescription: {
    id: 'dashboard.warranty.description',
    defaultMessage: 'Check your warranty information. You need a VIN or serial number to access warranty information.',
    description: 'Warranty information description',
  },
  dealerLocatorTitle: {
    id: 'dashboard.tiles.dealerLocator.title',
    defaultMessage: 'Dealer Locator',
    description: 'Dealer locator title',
  },
  dealerLocatorDescription: {
    id: 'dashboard.dealerLocator.description',
    defaultMessage: 'Search for your closest dealer, check opening times and get in touch with your dealers.',
    description: 'Dealer locator description',
  },
  manualsTitle: {
    id: 'dashboard.tiles.manuals.title',
    defaultMessage: 'Operator Manuals',
    description: 'Operator Manuals title',
  },
  manualsDescription: {
    id: 'dashboard.manuals.description',
    defaultMessage: 'Find your operator manuals and search within them for the information you need.',
    description: 'Manuals description',
  },
  manualsDescription2: {
    id: 'dashboard.manuals.description2',
    defaultMessage:
      'Access your operator manuals for FREE and purchase professional service manuals for your machines today.',
    description: 'Manuals description 2',
  },
  pspTitle: {
    id: 'dashboard.tiles.psp.title',
    defaultMessage: 'Product Support Programs (PSPs)',
    description: 'PSP title',
  },
  pspDescription: {
    id: 'dashboard.psp.description',
    defaultMessage:
      'Check whether your fleet is eligible for any manufacturer-supported repair programs. Access to the PSP requires a VIN or serial number for each vehicle.',
    description: 'PSP information description',
  },
  troubleCodesTitle: {
    id: 'dashboard.tiles.dtc.title',
    defaultMessage: 'Diagnostic Trouble Codes',
    description: 'Trouble codes title',
  },
  troubleCodesDescription: {
    id: 'dashboard.troubleCodes.description',
    defaultMessage: 'Search for your Trouble Codes to obtain more information.',
    description: 'Trouble codes description',
  },
  fendtOneTitle: {
    id: 'dashboard.tiles.fendtOne.title',
    defaultMessage: 'FendtONE',
    description: 'FendtONE title',
  },
  fendtOneDescription: {
    id: 'dashboard.fendtOne.description',
    defaultMessage:
      'Manage your operations & connectivity with ease and experience a seamless On/Offboard Experience for your Fendt equipment.',
    description: 'FendtONE description',
  },
  videosTitle: {
    id: 'dashboard.tiles.videos',
    defaultMessage: 'Videos',
    description: 'Videos title',
  },
  videosDescription: {
    id: 'dashboard.videos.description',
    defaultMessage: 'Explore & Learn: Video help for your machinery needs.',
    description: 'Videos description',
  },
  expertLinkTitle: {
    id: 'dashboard.tiles.expertLink.title',
    defaultMessage: 'ExpertLink',
    description: 'ExpertLink title',
  },
  expertLinkDescription: {
    id: 'dashboard.expertLink.description',
    defaultMessage: 'Unlock Direct Access to AGCO Customer Support',
    description: 'ExpertLink description',
  },
  contactUsTitle: {
    id: 'dashboard.tiles.contactUs.title',
    defaultMessage: 'Contact Us',
    description: 'Contact us title',
  },
  contactUsDescription: {
    id: 'dashboard.contactUs.description',
    defaultMessage: 'We are happy to help you, please tell us, what we can do for you today.',
    description: 'Contact us description',
  },
  updateMarketingPreferencesModalTitle: {
    id: 'dashboard.updateMarketingPreferencesModal.title',
    defaultMessage: 'Update your marketing preferences',
    description: 'Update marketing preferences modal title',
  },
  updateMarketingPreferencesModalDescription: {
    id: 'dashboard.updateMarketingPreferencesModal.description',
    defaultMessage: 'Please review and update your marketing preferences to receive communication.',
    description: 'Update marketing preferences modal description',
  },
  updateMarketingPreferencesModalPrimaryButton: {
    id: 'dashboard.updateMarketingPreferencesModal.primaryButton',
    defaultMessage: 'Choose your preferences',
    description: 'Update marketing preferences modal primary button label',
  },
});

export default messages;
